// extracted by mini-css-extract-plugin
export default {"image":"image-sM_kc","imageTest":"image-test-kNsji","team":"team-mew8q"};